import styled from "styled-components"

const Container = styled.div`
        display: flex;
        flex-direction: column;
        height: 80vh;
        width: 80vw;
        @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
            width: 100%;
        }
        `

const Header = styled.div`
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding: 10px;
        gap: 24px;
        margin-bottom: 12px;

        @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
            display: none;
        }
        `


const MobileToggle = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
`

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 75px;
  margin-bottom: 20px;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${p => (p.$active ? p.theme.colors.brand.blueOmint : '#fff')};
  color: ${p => (p.$active ? '#fff' : '#333')};
  border-color: ${p => (p.$active ? p.theme.colors.brand.blueOmint : '#ddd')};

  &:hover {
    border-color: ${p => p.theme.colors.brand.blueOmint};
  }
`

const Title = styled.h1`
        font-size: 24px;
        font-weight: 600;
        margin: 0;
        `

const SearchSection = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 15px;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        margin-bottom: 24px;
        `

const EditSearchSection = styled.div`
        width: 100%;
        `

const FilterGrid = styled.div`
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 15px;
        margin-bottom: 20px;
        `

const FilterGroup = styled.div`
        display: flex;
        flex-direction: column;
        `

const FilterLabel = styled.label`
        font-size: 16px;
        margin-bottom: 8px;
        `

const FilterSelect = styled.select`
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;
        background-color: white;
        cursor: pointer;

        &:focus {
            outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
    }
        `

const FilterInput = styled.input`
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;

        &:focus {
            outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
    }
        `

const DatePickerWrapper = styled.div`
    .react-datepicker__month-container{
        width: 100%;}

        .react-datepicker-wrapper {
            width: 100%;
    }

        .react-datepicker__input-container {
            width: 100%;
    }

        input {
            width: 100%;
        padding: 10px 40px 10px 16px;
        border: 1px solid rgb(152, 152, 152);
        border-radius: 8px;
        font-size: 16px;
        background-color: white;

        &:focus {
            outline: none;
        border-color: #0066cc;
        box-shadow: 0 0 0 2px rgba(0, 102, 204, 0.1);
        }
    }

        .react-datepicker {
            border: 1px solid #ddd;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        font-family: inherit;
    }

        .react-datepicker__header {
        background-color: #0066cc;
        border-bottom: 1px solid #0066cc;
    }

        .react-datepicker__day-name,
        .react-datepicker__day {
            width: 2.3rem;
        line-height: 2.3rem;
    }

        .react-datepicker__day--selected,
        .react-datepicker__day--keyboard-selected,
        .react-datepicker__day--in-selecting-range.react-datepicker__day--range-start,
        .react-datepicker__day--in-selecting-range.react-datepicker__day--range-end,
        .react-datepicker__day--in-range {
            background-color: #0066cc;
        color: white;
    }

        .react-datepicker__day--range-start,
        .react-datepicker__day--range-end {
            background-color: #0066cc;
        color: white;
    }

        .react-datepicker__day--in-range {
            background-color: #e3f2fd;
        color: #333;
    }

        .react-datepicker__day:hover {
            background-color: #f0f0f0;
    }

        .react-datepicker__day--selected:hover,
        .react-datepicker__day--in-range:hover {
            background-color: #0052a3;
        color: white;
    }

        .react-datepicker__current-month {
            color: white;
        font-weight: 600;
    }
        `

const SearchButtonsContainer = styled.div`
        display: flex;
        gap: 10px;
        `

const SearchButton = styled.button`
        padding: 12px;
        background-color: ${props => props.theme.colors.brand.blueOmint};
        color: white;
        border: none;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
	    width: ${({ width }) => (width ? `${width}` : '12rem')};

        @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
            width: 100%;
        }
        `

const CancelButton = styled.button`
        padding: 12px;
        background-color: white;
        color: #333333;
        border: 1px solid #ddd;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;

        &:hover {
            background-color: #f5f5f5;
    }
        `

const SearchInfo = styled.div`
        display: flex;
        flex-direction: column;
        gap: 6px;
        `

const SearchText = styled.span`
        font-size: 16px;
        color: #333;
        font-weight: bold;
        `

const SearchTextDesc = styled.span`
        font-size: 16px;
        color: #4D4D4D;
        `
const EditButton = styled.button`
        background: none;
        border: none;
        color: ${props => props.theme.colors.brand.blueOmint};
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 5px;
        margin-left: auto;
        
        &:hover {
            text-decoration: underline;
    }
        `

const ContentWrapper = styled.div`
        display: flex;
        flex: 1;
        overflow: hidden;

        `

const Sidebar = styled.div`
        width: 400px;
        overflow-y: auto;
        margin-right: 10px;
        display: ${p => p.$hidden ? 'none' : 'block'};

        @media (max-width: 768px) {
            width: 100%;
        border-right: none;
        margin-right: 0;
        display: ${p => p.$hidden ? 'none' : 'block'};
    }
        `

const ResultsCount = styled.div`
        font-size: 14px;
        color: #666;
        margin-bottom: 15px;
        `

const FilterToggle = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
        margin-bottom: 1rem;
        `

const Toggle = styled.label`
        position: relative;
        display: inline-block;
        width: 50px;
        height: 24px;
        `

const ToggleInput = styled.input`
        opacity: 0;
        width: 0;
        height: 0;

        &:checked + span {
            background-color: ${p => p.theme.colors.brand.blueOmint};
    }

        &:checked + span:before {
            transform: translateX(26px);
    }
        `

const ToggleSlider = styled.span`
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        transition: 0.4s;
        border-radius: 24px;
        box-shadow: inset 0 0 0 1px #bbb;

        &:before {
        position: absolute;
        content: '';
        height: 18px;
        width: 18px;
        left: 3px;
        bottom: 3px;
        transition: 0.4s;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0,0,0,0.3);
    }
        `

const ResultsList = styled.div`
        padding: 0;
        `

const ResultCard = styled.div`
        border: 1px solid #e0e0e0;
        cursor: pointer;
        margin-bottom: 1rem;
        border-radius: 8px;
        padding: 16px;
        background-color: ${props => props.isSelected ? '#e3f2fd' : 'white'};
        border-color: ${props => props.isSelected ? '#0066cc' : '#e0e0e0'};
        border-width: ${props => props.isSelected ? '2px' : '1px'};
        transition: all 0.2s ease;

        &:hover {
            background-color: ${props => props.isSelected ? '#e3f2fd' : '#f9f9f9'};
    }
        `

const DoctorName = styled.h3`
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 4px 0;
        color: #333;
        `

const Specialty = styled.div`
        font-size: 14px;
        color: #525252;
        margin-bottom: 18px;
        `

const ClinicInfo = styled.div`
        display: flex;
        align-items: start;
        gap: 8px;
        margin-bottom: 8px;
        font-size: 14px;
        `

const Icon = styled.span`
        margin-top: 2px;
        `

const AppointmentInfo = styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 10px 0;
        font-size: 14px;
        `

const BookButton = styled.button`
        width: 100%;
        padding: 10px;
        border: 1px solid ${props => props.theme.colors.brand.blueOmint};
        color: ${props => props.theme.colors.brand.blueOmint};
        font-size: 16px;
        font-weight: 600;
        border-radius: 8px;
        cursor: pointer;
        margin-top: 10px;
        background-color: white;

        &:hover {
        background-color: #0066cc;
        color: white;
    }
        `

const MapWrapper = styled.div`
        flex: 1;
        position: relative;
        display: ${p => p.$hidden ? 'none' : 'block'};

        @media (max-width: 768px) {
            display: ${p => p.$hidden ? 'none' : 'block'};
    }
        `

const FiltersModal = styled.div`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        display: flex;
        align-items: flex-end;
        `

const ModalOverlay = styled.div`
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.4);
        `

const ModalContent = styled.div`
        position: relative;
        background-color: white;
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        border-radius: 16px 16px 0 0;
        padding: 20px;
        box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
        animation: slideUp 0.3s ease-out;

        @keyframes slideUp {
            from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }
        `

const ModalHeader = styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e0e0e0;
        `

const ModalTitle = styled.h2`
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        color: #333;
        `

const CloseButton = styled.button`
        background: none;
        border: none;
        font-size: 28px;
        color: #999;
        cursor: pointer;
        padding: 0;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.2s ease;

        &:hover {
            background-color: #f0f0f0;
        color: #333;
    }
        `

const ModalFilterGrid = styled.div`
        display: grid;
        grid-template-columns: 1fr;
        gap: 15px;
        margin-bottom: 20px;
        `

const ModalFooter = styled.div`
        display: flex;
        gap: 10px;
        margin-top: 20px;
        padding-top: 15px;
        border-top: 1px solid #e0e0e0;
        `

const ClinicModalWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1001;
    display: flex;
    align-items: flex-end;
    display: none;

    @media (max-width: 768px) {
        display: flex;
    }
    `

const ClinicModalOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    `

const ClinicModalContent = styled.div`
    position: relative;
    background-color: white;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 16px 16px 0 0;
    padding: 20px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
        transform: translateY(100%);
        }
        to {
        transform: translateY(0);
        }
    }
    `

const ClinicModalHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
    `

const ClinicModalTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 8px 0;
    color: #333;
    `

const ClinicResultsCount = styled.div`
    font-size: 14px;
    color: #666;
    margin: 0;
    `

const ClinicCloseButton = styled.button`
    background: none;
    border: none;
    font-size: 28px;
    color: #999;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    margin-top: -8px;

    &:hover {
        background-color: #f0f0f0;
        color: #333;
    }
    `

const ClinicDoctorsList = styled.div`
    padding: 0;
    `

const ClinicDoctorCard = styled.div`
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
    border-radius: 8px;
    padding: 15px;
    background-color: white;
    transition: all 0.2s ease;

    &:hover {
        background-color: #f9f9f9;
        border-color: #d0d0d0;
    }
    `

const ClinicDoctorName = styled.h3`
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 5px 0;
    color: #333;
    `

const ClinicDoctorSpecialty = styled.div`
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
    `

const ClinicLocationInfo = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    font-size: 13px;
    color: #666;
    `

const ClinicAppointmentInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 10px 0;
    font-size: 13px;
    color: #666;
    `

const ClinicBookButton = styled.button`
    width: 100%;
    padding: 12px;
    border: 1px solid ${props => props.theme.colors.brand.blueOmint};
    color: ${props => props.theme.colors.brand.blueOmint};
    font-size: 14px;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    margin-top: 10px;
    background-color: white;
    transition: all 0.2s ease;

    &:hover {
        background-color: ${props => props.theme.colors.brand.blueOmint};
        color: white;
    }
    `
const SearchDiv = styled.div`
    display: flex;
    gap: 12px;
`

const SearchHeader = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`

export {
    Container,
    Header,
    MobileToggle,
    ToggleButton,
    Title,
    SearchSection,
    EditSearchSection,
    FilterGrid,
    FilterGroup,
    FilterLabel,
    DatePickerWrapper,
    SearchButtonsContainer,
    SearchButton,
    CancelButton,
    SearchInfo,
    SearchText,
    SearchTextDesc,
    EditButton,
    ContentWrapper,
    Sidebar,
    ResultsCount,
    FilterToggle,
    Toggle,
    ToggleInput,
    ToggleSlider,
    ResultsList,
    ResultCard,
    DoctorName,
    Specialty,
    ClinicInfo,
    Icon,
    AppointmentInfo,
    BookButton,
    MapWrapper,
    FiltersModal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalTitle,
    CloseButton,
    ModalFilterGrid,
    ModalFooter,
    ClinicModalWrapper,
    ClinicModalOverlay,
    ClinicModalContent,
    ClinicModalHeader,
    ClinicModalTitle,
    ClinicResultsCount,
    ClinicCloseButton,
    ClinicDoctorsList,
    ClinicDoctorCard,
    ClinicDoctorName,
    ClinicDoctorSpecialty,
    ClinicLocationInfo,
    ClinicAppointmentInfo,
    ClinicBookButton,
    SearchDiv,
    SearchHeader
}